export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5455.bfc3d394.jpg";